/* Footer reveal. Each column rises into place out of a slight blur the first
   time it scrolls into view, then is left alone.

   The columns are only hidden once this script has decided it can show them
   again: without IntersectionObserver, or in the theme editor (the section
   renders without m-ft--reveal there), the footer is left exactly as the
   markup draws it. A reduced-motion preference still arms it, and the CSS
   turns the rise into a short opacity fade with no movement. */
(function () {
  function arm(root) {
    if (!root.classList.contains('m-ft--reveal')) return;
    if (!('IntersectionObserver' in window)) return;

    var items = root.querySelectorAll('[data-m-ft-item]');
    if (!items.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -40px 0px' }
    );

    root.classList.add('m-ft--armed');
    items.forEach(function (item) { io.observe(item); });
  }

  document.querySelectorAll('[data-m-ft]').forEach(arm);
})();
